export function useConstructor() {
    const app = getCurrentInstance()?.proxy?.$root;
    const auth = useAuthStore();
    const helper = useHelperStore();
    const layout = useLayoutStore();
    const module = useModuleStore();
    const response = useResponseStore();
    const route = useRoute();
    const router = useRouter();
    const { t, locale } = useI18n();

    return {
        app,
        auth,
        can: auth.can,
        helper,
        layout,
        locale,
        module,
        response,
        route,
        router,
        t,
    };
}
